<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item active" aria-current="page">Capacity</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Capacity Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="capacity; else noCapacity">
    <div class="card-body">
      <!-- Capacity Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Display Name:</strong> {{ capacity.displayName }}
        </li>
        <li class="list-group-item" *ngIf="capacity.admins[0]; else noAdmins">
            <strong>Admins:</strong>
            <ul class="list-unstyled mt-2">
              <li *ngFor="let admin of capacity.admins">
                    {{ admin }}
              </li>
            </ul>
        </li>
        <ng-template #noAdmins>
            <li class="list-group-item">
                <strong>Admins:</strong> No admins assigned
            </li>
        </ng-template>
        <li class="list-group-item">
            <strong>SKU:</strong> {{ capacity.sku }}
        </li>
        <li class="list-group-item">
            <strong>State:</strong> {{ capacity.state }}
        </li>
        <li class="list-group-item">
            <strong>User Accessrights:</strong> {{ capacity.capacityUserAccessRight }}
        </li>
        <li class="list-group-item">
            <strong>Region:</strong> {{ capacity.region }}
        </li>
      </ul>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if capacity is not available -->
<ng-template #noCapacity>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No capacity available.
  </div>
</ng-template>
